let application = {
  path: 'application',
  name: 'application',
  component: () => import('@/views/application/index.vue'),
  meta: {
    name: '应用'
  },
  children: [
    {
      path: 'applyList',
      name: 'applyList',
      component: () => import('@/views/application/applyList.vue'),
      meta: {
        name: '应用列表'
      }
    },
    {
      path: 'wxApp/index',
      name: 'wxAppIndex',
      component: () => import('@/views/application/wxApp/index.vue'),
      meta: {
        name: '微信小程序'
      }
    },
    {
      path: 'wxApp/customerService',
      name: 'customerServiceIndex',
      component: () => import('@/views/application/wxApp/customerService.vue'),
      meta: {
        name: '微信客服'
      }
    },
    {
      path: 'smsPush/index',
      name: 'smsPushIndex',
      component: () => import('@/views/application/smsPush/index.vue'),
      meta: {
        name: '短信推送'
      }
    },
    {
      path: 'housekeeping/index',
      name: 'housekeepingIndex',
      component: () => import('@/views/application/housekeeping/index.vue'),
      meta: {
        name: '家政服务'
      }
    },
    {
      path: 'thirdParty/index',
      name: 'thirdPartyIndex',
      component: () => import('@/views/application/thirdParty/index.vue'),
      meta: {
        name: '三方平台'
      }
    },
    {
      path: 'serviceTime/index',
      name: 'serviceTimeIndex',
      component: () => import('@/views/application/serviceTime/index.vue'),
      meta: {
        name: '服务时间'
      }
    },
    {
      path: 'serviceTime/detail/:id',
      name: 'serviceTimeDetailIndex',
      component: () => import('@/views/application/serviceTime/detail.vue'),
      meta: {
        name: '服务时间详情'
      }
    },
    {
      path: 'coupons/index',
      name: 'couponsIndex',
      component: () => import('@/views/application/coupons/index.vue'),
      meta: {
        name: '优惠券'
      }
    },
    {
      path: 'coupons/batchCouponDetail/:id',
      name: 'batchCouponDetail',
      component: () => import('@/views/application/coupons/batchCouponDetail.vue'),
      meta: {
        name: '批量发券详情'
      }
    },
    {
      path: 'markeActivitie/index',
      name: 'markeActivitieIndex',
      component: () => import('@/views/application/markeActivitie/index.vue'),
      meta: {
        name: '营销活动'
      }
    },
    {
      path: 'markeActivitie/letCoupon',
      name: 'letCouponIndex',
      component: () => import('@/views/application/markeActivitie/letCoupon/letCoupon.vue'),
      meta: {
        name: '扫码领券'
      }
    },
    {
      path: 'markeActivitie/newLetcoupon/:id',
      name: 'newLetcouponnIndex',
      component: () => import('@/views/application/markeActivitie/letCoupon/newLetcoupon.vue'),
      meta: {
        name: '扫码领券-新建'
      }
    },
    {
      path: 'advertList/advertList',
      name: 'advertListIndex',
      component: () => import('@/views/application/advertList/advertList.vue'),
      meta: {
        name: '广告位'
      }
    },
    {
      path: 'markeActivitie/luckCoupon',
      name: 'fightHardIndex',
      component: () => import('@/views/application/markeActivitie/luckCoupon/luckCoupon.vue'),
      meta: {
        name: '拼手气抢券'
      }
    },
    {
      path: 'markeActivitie/newLuckCoupon/:id',
      name: 'newLuckCouponIndex',
      component: () => import('@/views/application/markeActivitie/luckCoupon/newLuckCoupon.vue'),
      meta: {
        name: '新建拼手气抢券'
      }
    },
    {
      path: 'markeActivitie/luckCouponEffect/:id',
      name: 'luckCouponEffectIndex',
      component: () => import('@/views/application/markeActivitie/luckCoupon/luckCouponEffect.vue'),
      meta: {
        name: '活动效果'
      }
    },
    {
      path: 'markeActivitie/sendCoupon',
      name: 'sendCouponIndex',
      component: () => import('@/views/application/markeActivitie/sendCoupon/sendCoupon.vue'),
      meta: {
        name: '礼券售卖'
      }
    },
    {
      path: 'markeActivitie/newSendCoupon/:id',
      name: 'newSendCouponIndex',
      component: () => import('@/views/application/markeActivitie/sendCoupon/newSendCoupon.vue'),
      meta: {
        name: '礼券售卖'
      }
    },

    {
      path: 'markeActivitie/sendCouponDetail/:id',
      name: 'sendCouponDetailIndex',
      component: () => import('@/views/application/markeActivitie/sendCoupon/sendCouponDetail.vue'),
      meta: {
        name: '礼券售卖-详情'
      }
    },
    {
      path: 'markeActivitie/newManCoupon',
      name: 'newManCouponIndex',
      component: () => import('@/views/application/markeActivitie/newManCoupon/index.vue'),
      meta: {
        name: '新人赠券'
      }
    },
    {
      path: 'markeActivitie/consumeCoupon',
      name: 'consumeCouponIndex',
      component: () => import('@/views/application/markeActivitie/consumeCoupon/index.vue'),
      meta: {
        name: '消费赠券'
      }
    },
    {
      path: 'markeActivitie/consumeCoupon/add',
      name: 'consumeCouponAdd',
      component: () => import('@/views/application/markeActivitie/consumeCoupon/add.vue'),
      meta: {
        name: '消费赠券/新建规则'
      }
    },
    {
      path: 'takeOut/index',
      name: 'takeOutIndex',
      component: () => import('@/views/application/takeOut/index.vue'),
      meta: {
        name: '外送'
      }
    },
    {
      path: 'userCup/userCup',
      name: 'cupIndex',
      component: () => import('@/views/application/userCup/userCup.vue'),
      meta: {
        name: '自带杯活动'
      }
    },
    {
      path: 'userCup/newCup',
      name: 'newCupIndex',
      component: () => import('@/views/application/userCup/newCup.vue'),
      meta: {
        name: '新建优惠券'
      }
    },
    {
      path: 'coupons/newCoupons/:type/:id',
      name: 'newCouponsIndex',
      component: () => import('@/views/application/coupons/newCoupons.vue'),
      meta: {
        name: '新建优惠券'
      }
    },
    {
      path: 'coupons/couponPack/:id',
      name: 'editCouponPackIndex',
      component: () => import('@/views/application/coupons/couponPack.vue'),
      meta: {
        name: '券包列表'
      }
    },
    {
      path: 'coupons/newVersion/:type/:id',
      name: 'newVersionIndex',
      component: () => import('@/views/application/coupons/newVersion.vue'),
      meta: {
        name: '历史版本'
      }
    },

    {
      path: 'markeActivitie/invitationCoupon',
      name: 'invitationCouponIndex',
      component: () => import('@/views/application/markeActivitie/invitationCoupon/invitationCoupon.vue'),
      meta: {
        name: '邀请有礼'
      }
    },
    {
      path: 'markeActivitie/newInvitationCoupon/:id',
      name: 'newInvitationCouponIndex',
      component: () => import('@/views/application/markeActivitie/invitationCoupon/newInvitationCoupon.vue'),
      meta: {
        name: '邀请有礼-新建'
      }
    },
    {
      path: 'markeActivitie/invitationCouponEffect/:id',
      name: 'invitationCouponEffectIndex',
      component: () => import('@/views/application/markeActivitie/invitationCoupon/invitationCouponEffect.vue'),
      meta: {
        name: '邀请有礼-查看效果'
      }
    },
    {
      path: 'markeActivitie/letCouponEffect/:id',
      name: 'letCouponEffectIndex',
      component: () => import('@/views/application/markeActivitie/letCoupon/letCouponEffect.vue'),
      meta: {
        name: '扫码领券-查看效果'
      }
    },

    {
      path: 'markeActivitie/expandCoupon/expandCoupon',
      name: 'expandCouponIndex',
      component: () => import('@/views/application/markeActivitie/expandCoupon/expandCoupon.vue'),
      meta: {
        name: '膨胀券'
      }
    },
    {
      path: 'markeActivitie/expandCoupon/newExpandCoupon/:id',
      name: 'newExpandCouponIndex',
      component: () => import('@/views/application/markeActivitie/expandCoupon/newExpandCoupon.vue'),
      meta: {
        name: '膨胀券-新建'
      }
    },
    {
      path: 'markeActivitie/expandCoupon/expandCouponEffect/:id',
      name: 'expandCouponEffectIndex',
      component: () => import('@/views/application/markeActivitie/expandCoupon/expandCouponEffect.vue'),
      meta: {
        name: '膨胀券-查看效果'
      }
    },
    {
      path: 'memberGrade/index',
      name: 'memberGradeIndex',
      component: () => import('@/views/application/memberGrade/index.vue'),
      meta: {
        name: '会员等级'
      }
    },
    {
      path: 'memberPoints/index',
      name: 'memberPointsIndex',
      component: () => import('@/views/application/memberPoints/index.vue'),
      meta: {
        name: '会员积分'
      }
    },
    {
      path: 'memberPoints/newPointsProduct/:id',
      name: 'newPointsProductIndex',
      component: () => import('@/views/application/memberPoints/newPointsProduct.vue'),
      meta: {
        name: '新建积分商品'
      }
    },
    {
      path: 'enterpriseWeChat/index',
      name: 'enterpriseWeChatIndex',
      component: () => import('@/views/application/enterpriseWeChat/index.vue'),
      meta: {
        name: '企业微信'
      }
    },
    {
      path: 'enterpriseWeChat/newGroupMessages/:type/:id',
      name: 'newGroupMessagesIndex',
      component: () => import('@/views/application/enterpriseWeChat/newGroupMessages.vue'),
      meta: {
        name: '企业微信-新建群发'
      }
    },
    {
      path: 'enterpriseWeChat/groupMessagesDetail/:id',
      name: 'groupMessagesDetailIndex',
      component: () => import('@/views/application/enterpriseWeChat/groupMessagesDetail.vue'),
      meta: {
        name: '企业微信-群发详情'
      }
    },
    {
      path: 'enterpriseWeChat/workerDetail/:id',
      name: 'workerDetailIndex',
      component: () => import('@/views/application/enterpriseWeChat/workerDetail.vue'),
      meta: {
        name: '企业微信-员工详情'
      }
    },
    {
      path: 'enterpriseWeChat/communityDetail/:id',
      name: 'communityDetailIndex',
      component: () => import('@/views/application/enterpriseWeChat/communityDetail.vue'),
      meta: {
        name: '企业微信-社群详情'
      }
    },
    {
      path: 'youCard/list',
      name: 'youCardIndex',
      component: () => import('@/views/application/youCard/list.vue'),
      meta: {
        name: '优卡列表'
      }
    },
    {
      path: 'youCard/addOrEdit/:id',
      name: 'addOrEditIndex',
      component: () => import('@/views/application/youCard/addOrEdit.vue'),
      meta: {
        name: '新建优卡'
      }
    },
    {
      path: 'youCard/redeemCode/:id',
      name: 'redeemCodeIndex',
      component: () => import('@/views/application/youCard/redeemCode.vue'),
      meta: {
        name: '兑换码'
      }
    },
    {
      path: 'washCareAction/index',
      name: 'washCareActionIndex',
      component: () => import('@/views/application/washCareAction/index.vue'),
      meta: {
        name: '取送和到店'
      }
    },
    {
      path: 'washCare/index',
      name: 'washCareIndex',
      component: () => import('@/views/application/washCare/index.vue'),
      meta: {
        name: '洗护功能'
      }
    },
    {
      path: 'clothing/list',
      name: 'clothingIndex',
      component: () => import('@/views/application/clothing/list.vue'),
      meta: {
        name: '衣物管理'
      }
    },
    {
      path: 'clothing/clothDetail/:id',
      name: 'clothDetailIndex',
      component: () => import('@/views/application/clothing/clothDetail.vue'),
      meta: {
        name: '衣物详情'
      }
    },
    {
      path: 'tableCode/index',
      name: 'tableCodeIndex',
      component: () => import('@/views/application/tableCode/index.vue'),
      meta: {
        name: '桌码'
      }
    },
    {
      path: 'markeActivitie/handCoupon/index',
      name: 'handCouponIndex',
      component: () => import('@/views/application/markeActivitie/handCoupon/index.vue'),
      meta: {
        name: '手动发券'
      }
    },
    {
      path: 'markeActivitie/invite/index',
      name: 'inviteIndex',
      component: () => import('@/views/application/markeActivitie/invite/index.vue'),
      meta: {
        name: '请Ta'
      }
    },
    {
      path: 'jinDong/index',
      name: 'jinDongIndex',
      component: () => import('@/views/application/jinDong/index.vue'),
      meta: {
        name: '京东快递'
      }
    },
    {
      path: 'jinDong/addDebitCard/:type',
      name: 'addDebitCardIndex',
      component: () => import('@/views/application/jinDong/addDebitCard.vue'),
      meta: {
        name: '新建结算卡'
      }
    },
    {
      path: 'jinDong/debitCardDetail/:id',
      name: 'debitCardDetailIndex',
      component: () => import('@/views/application/jinDong/debitCardDetail.vue'),
      meta: {
        name: '结算卡详情'
      }
    },
    {
      path: 'shunfeng/index',
      name: 'shunfengIndex',
      component: () => import('@/views/application/shunfeng/index.vue'),
      meta: {
        name: '顺丰'
      }
    },
    {
      path: 'shunfeng/addDebitCard/:type',
      name: 'sfAddDebitCardIndex',
      component: () => import('@/views/application/shunfeng/addDebitCard.vue'),
      meta: {
        name: '新建结算卡'
      }
    },
    {
      path: 'shunfeng/debitCardDetail/:id',
      name: 'sfDebitCardDetailIndex',
      component: () => import('@/views/application/shunfeng/debitCardDetail.vue'),
      meta: {
        name: '结算卡详情'
      }
    },
    {
      path: 'intraCityService/index',
      name: 'intraCityServiceIndex',
      component: () => import('@/views/application/intraCityService/index.vue'),
      meta: {
        name: '同城配送'
      }
    },
    {
      path: 'meituanReview/index',
      name: 'meituanReviewIndex',
      component: () => import('@/views/application/meituanReview/index.vue'),
      meta: {
        name: '美团点评'
      }
    },
    {
      path: 'washCareAction/deliveryDetail/:expressNo',
      name: 'deliveryDetailIndex',
      component: () => import('@/views/application/washCareAction/deliveryDetail.vue'),
      meta: {
        name: '快递详情'
      }
    },
    {
      path: 'evaluateRecovery/index',
      name: 'evaluateRecoveryIndex',
      component: () => import('@/views/application/evaluateRecovery/index.vue'),
      meta: {
        name: '估价回收'
      }
    },
    {
      path: 'evaluateRecoveryCard/index',
      name: 'evaluateRecoveryCardIndex',
      component: () => import('@/views/application/evaluateRecoveryCard/index.vue'),
      meta: {
        name: '估价卡'
      }
    },
    {
      path: 'markeActivitie/preferentialCode/list',
      name: 'preferentialCodeIndex',
      component: () => import('@/views/application/markeActivitie/preferentialCode/list.vue'),
      meta: {
        name: '优惠码'
      }
    },
    {
      path: 'markeActivitie/preferentialCode/addOrEdit/:id',
      name: 'updIndex',
      component: () => import('@/views/application/markeActivitie/preferentialCode/addOrEdit.vue'),
      meta: {
        name: '新建优惠码'
      }
    },
    {
      path: 'markeActivitie/preferentialCode/redeemCode/:id',
      name: 'pCodeIndex',
      component: () => import('@/views/application/markeActivitie/preferentialCode/redeemCode.vue'),
      meta: {
        name: '优惠码'
      }
    },
    {
      path: 'markeActivitie/pointsCoupons/index',
      name: 'pointsCouponsIndex',
      component: () => import('@/views/application/markeActivitie/pointsCoupons/index.vue'),
      meta: {
        name: '集点赠券'
      }
    },
    {
      path: 'markeActivitie/memberDiscountCard/index',
      name: 'memberDiscountCardIndex',
      component: () => import('@/views/application/markeActivitie/memberDiscountCard/index.vue'),
      meta: {
        name: '会员折扣卡'
      }
    },
    {
      path: 'markeActivitie/memberDiscountCard/create/:id?',
      name: 'memberDiscountCardCreate',
      component: () => import('@/views/application/markeActivitie/memberDiscountCard/create.vue'),
      meta: {
        name: '会员折扣卡-新建/编辑'
      }
    },
    {
      path: 'markeActivitie/memberDiscountCard/effect/:id?',
      name: 'memberDiscountCardEffect',
      component: () => import('@/views/application/markeActivitie/memberDiscountCard/effect.vue'),
      meta: {
        name: '会员折扣卡-活动效果'
      }
    },
    {
      path: 'douyin/index',
      name: 'douyinIndex',
      component: () => import('@/views/application/douyin/index.vue'),
      meta: {
        name: '抖音'
      }
    },
    {
      path: 'douyin/app',
      name: 'douyinApp',
      component: () => import('@/views/application/douyin/app.vue'),
      meta: {
        name: '抖音小程序'
      }
    },
    {
      path: 'douyin/addProduct',
      name: 'douyinAddProduct',
      component: () => import('@/views/application/douyin/components/addProduct.vue'),
      meta: {
        name: '抖音-新建/编辑商品'
      }
    },
    {
      path: 'distribution/index',
      name: 'distributionIndex',
      component: () => import('@/views/application/distribution/index.vue'),
      meta: {
        name: '分销'
      }
    },
    {
      path: 'insurance/index',
      name: 'insuranceIndex',
      component: () => import('@/views/application/insurance/index.vue'),
      meta: {
        name: '保险'
      }
    },
    {
      path: 'insurance/warrantyDetail/:insureNo',
      name: 'warrantyDetail',
      component: () => import('@/views/application/insurance/warrantyDetail.vue'),
      meta: {
        name: '保单详情'
      }
    },
    {
      path: 'matchingOrder/index',
      name: 'matchingOrder',
      component: () => import('@/views/application/matchingOrder/index.vue'),
      meta: {
        name: '配单'
      }
    },
    {
      path: 'team/index',
      name: 'team',
      component: () => import('@/views/application/team/index.vue'),
      meta: {
        name: '团体单位'
      }
    },
    {
      path: 'team/detail/:id',
      name: 'teamDetail',
      component: () => import('@/views/application/team/detail.vue'),
      meta: {
        name: '团体单位详情'
      }
    },
    {
      path: 'device/index',
      name: 'deviceIndex',
      component: () => import('@/views/application/device/index.vue'),
      // component: () => import('@/views/application/customerService/index.vue'),
      meta: {
        name: '智能设备'
      }
    },
    {
      path: 'device/detail/:id',
      name: 'deviceDetail',
      component: () => import('@/views/application/device/detail.vue'),
      meta: {
        name: '智能设备详情'
      }
    },
    {
      path: 'customerService/index',
      name: 'customerService',
      component: () => import('@/views/application/customerService/index.vue'),
      meta: {
        name: '空中客服'
      }
    },
    {
      path: 'customerService/detail/:id',
      name: 'customerServiceDetail',
      component: () => import('@/views/application/customerService/detail.vue'),
      meta: {
        name: '会话详情'
      }
    },
    {
      path: 'storePartner/index',
      name: 'storePartner',
      component: () => import('@/views/application/storePartner/index.vue'),
      meta: {
        name: '店铺伙伴'
      }
    },
    {
      path: 'washCode/index',
      name: 'washCode',
      component: () => import('@/views/application/washCode/index.vue'),
      meta: {
        name: '洗衣码'
      }
    },
    {
      path: 'washCode/detail',
      name: 'washCodeDetail',
      component: () => import('@/views/application/washCode/detail.vue'),
      meta: {
        name: '洗衣码批次'
      }
    },
    {
      path: 'apiOrder/index',
      name: 'apiOrder',
      component: () => import('@/views/application/apiOrder/index.vue'),
      meta: {
        name: 'API接口下单'
      }
    },
    {
      path: 'apiOrder/add',
      name: 'apiOrderAdd',
      component: () => import('@/views/application/apiOrder/add.vue'),
      meta: {
        name: 'API接口下单-添加账号'
      }
    },
    {
      path: 'apiOrder/detail/:id',
      name: 'apiOrderDetail',
      component: () => import('@/views/application/apiOrder/detail.vue'),
      meta: {
        name: 'API接口下单-账号详情'
      }
    },
    {
      path: 'cloudPrint/index',
      name: 'cloudPrint',
      component: () => import('@/views/application/cloudPrint/index.vue'),
      meta: {
        name: '云打印'
      }
    },
    {
      path: 'groupVoucherRedeem/index',
      name: 'groupVoucherRedeemIndex',
      component: () => import('@/views/application/groupVoucherRedeem/index.vue'),
      meta: {
        name: '团购核销'
      }
    }
  ]
}

export default application
